import axiosPost from "./axiosPost";

export const RNHUnidadGet = async (credentials, data) => {
    const body = {
        service: "RNHUnidadGet",
        params: {
            rnhUnidadId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
